import { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { progressVariants } from './Progress.variants'
import { getProgressPercentage } from './utils/getProgressPercentage'

export interface ProgressProps extends HTMLAttributes<HTMLDivElement> {
  value: number
  max?: number
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ value, max = 100, accentColor = 'none', className, ...props }, ref) => {
    const percentage = getProgressPercentage(value, max)

    return (
      <div
        className={twMerge(
          'relative',
          'w-full h-2',
          'rounded-full bg-white/20 overflow-hidden',
          className
        )}
        ref={ref}
        role="progressbar"
        {...props}
      >
        <div className={progressVariants({ accentColor })} style={{ width: `${percentage}%` }} />
      </div>
    )
  }
)

Progress.displayName = 'Progress'
